import { CategoryType } from 'src/graphql';

export interface TransformedCategory {
  id: number;
  name: string;
  description: string;
  isDeterminedCategory: boolean;
  isReportedCategory: boolean;
  order: number;
  displayInApp: boolean;
  displayInOpenReporting: boolean;
  allowGoTogether: boolean;
  localeCodes: string[];
}

export const transformSpeakUpCategories = (
  data: CategoryType[] | null | undefined,
): TransformedCategory[] => {
  if (!data) return [];
  return data
    .filter((cat) => {
      if (!cat.locales || typeof cat.locales !== 'object') return false;
      const localeValues = Object.values(cat.locales) as Array<{
        name?: string;
      } | null>;
      return localeValues.some((locale) => locale?.name);
    })
    .map((cat) => {
      const locales = cat.locales as Record<
        string,
        { name?: string; description?: string }
      >;
      const enGBLocale = locales['en-GB'];
      const firstAvailableLocale = Object.values(locales).find(
        (locale) => locale?.name,
      );
      const selectedLocale = enGBLocale?.name
        ? enGBLocale
        : firstAvailableLocale;

      return {
        id: cat.id,
        name: selectedLocale?.name || '',
        description: selectedLocale?.description || '',
        isDeterminedCategory: cat.isDeterminedCategory,
        isReportedCategory: cat.isReportedCategory,
        order: cat.order,
        displayInApp: cat.displayInApp === true,
        displayInOpenReporting: cat.displayInOpenReporting === true,
        allowGoTogether: cat.allowGoTogether === true,
        localeCodes: Object.keys(locales).filter((key) => locales[key]?.name),
      };
    });
};

export const getCategoriesListForConfiguration = (
  categories: TransformedCategory[],
): TransformedCategory[] => categories;
